import { useDisclosure } from '@nextui-org/react';
import Link from 'next/link';
import React from 'react';

import { IconRunModel } from '@/assets';
import RemixCommon from '@/layouts/remix-common';
import { SIDEBAR_MENU_LINK } from '@/layouts/sidebar';
import type { Lora } from '@/types';
import { formatCash } from '@/utils';

import { Images } from '..';
import { IconDownload, IconHeartNotLiked, IconRun } from '../assets';
import AvatarPlaceholder from '../avatar-default';

interface TypeModel {
  [key: number]: string;
}

const TYPEMODEL: TypeModel = {
  1: 'CHECKPOINT',
  2: 'LORA',
};

const CardModelMasonry: React.FC<{
  model: Lora;
}> = ({ model }) => {
  const useModalRemix = useDisclosure({
    onClose() {
      document.body.style.removeProperty('overflow');
    },
  });
  const { onOpen } = useModalRemix;

  const handleUseUseCase = () => {
    document.body.style.overflow = 'hidden';
    onOpen();
  };
  
  return (
    <>
      <RemixCommon useModalRemix={useModalRemix} modelLoraSelected={model} />

      <Link
        href={`${SIDEBAR_MENU_LINK.aiModel}/${model.id}`}
        // onClick={() => router.push(`${SIDEBAR_MENU_LINK.aiModel}/${model.id}`)}
        className="group relative cursor-pointer overflow-hidden rounded-xl"
      >
        <Images
          src={model.previews[0] || ''}
          alt="usecase"
          className="h-full w-full cursor-pointer object-contain duration-500 group-hover:scale-110"
        />
        <div className="absolute left-3 top-3 z-10 inline-flex h-[22px] items-center gap-[2px] whitespace-nowrap rounded-full bg-black/50 px-2 text-[12px] font-medium uppercase text-white">
          <span>{TYPEMODEL[model.type]}</span>|<span>{model.baseModel}</span>
        </div>
        <div className="absolute right-2 top-3 z-10 inline-flex items-center ">
          <div
            onClick={(event) => {
              event.preventDefault();
              handleUseUseCase();
            }}
            className="flex h-fit w-fit items-center gap-1 rounded-[6px] bg-orange-500 px-2 py-1 text-[14px] font-medium text-white"
          >
            <span className="scale-75">
              <IconRunModel />
            </span>
            Run
          </div>
        </div>
        <div className="absolute bottom-0 left-0 z-10 h-[100px] w-full bg-gradient-to-t from-black/80 to-black/0" />
        <div className="absolute inset-x-0 bottom-0 z-10 p-3">
          <h6 className="truncate text-[16px] font-medium text-white drop-shadow">{model.name}</h6>
          <div className="mt-[8px] flex items-center justify-between">
            <div className="flex items-center">
              <AvatarPlaceholder
                width={18}
                height={18}
                src={model.creator.picture}
                address={model.creator.publicAddress}
                className="h-[18px] w-[18px] rounded-full object-cover"
              />
              <p className="ml-1 line-clamp-1 max-w-[150px] text-[12px] text-white">
                {model.creator.username || 'Unnamed'}
              </p>
            </div>
            <div className="flex items-center gap-[6px]">
              <div className="flex items-center">
                <IconHeartNotLiked width={16} height={16} color="white" />
                <span className="ml-1 text-[12px] text-white">{formatCash(model.likeCount)}</span>
              </div>
              <span className="h-1 w-1 rounded-full bg-white opacity-60" />
              <div className="flex items-center">
                <IconRun width={12} height={12} color="white" />
                <span className="ml-1 text-[12px] text-white">{formatCash(model.runCount)}</span>
              </div>
              {model.downloadCount > 0 && (
                <>
                  <span className="h-1 w-1 rounded-full bg-white opacity-60" />

                  <div className="flex items-center">
                    <IconDownload width={14} height={14} />
                    <span className="ml-1 text-[12px] text-white">
                      {formatCash(model.downloadCount)}
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};

export default CardModelMasonry;
